import { QueryClient } from "@tanstack/react-query";
import { redirect } from "react-router";
import { USER_TYPES } from "~/shared/api/users/users.constants";
import { USERS_QUERIES } from "~/shared/api/users/users.queries";

export async function accountTwoFactorAuthViewLoader(queryClient: QueryClient) {
  const [userProfile, preference] = await Promise.all([
    queryClient.ensureQueryData(USERS_QUERIES.profile()),
    queryClient.ensureQueryData(USERS_QUERIES.userAuthPreferences()),
  ]);

  if (preference.preferred !== "TOTP" && userProfile.type === USER_TYPES.breakline) {
    return null;
  }

  // If the user has already enabled 2FA, redirect them to the account page
  return redirect("/account");
}
